import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RfqList from './Rfq/List';
import RfqCreate from './Rfq/Create';
import RfqDetail from './Rfq/Detail';
import { injectIntl } from "react-intl";
import { paymentPeriods } from '../../../shared/lookup';
export { getQuoteFields, getQuoteReplyFields } from './Quotes/Router';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    StartDate: { visible: false, label: '', required: false },
    CompletionDate: { visible: false, label: '', required: false },
    DelayAmount: { visible: false, label: '', required: false },
    DelayPaymentPeriod: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Description = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };

    const payPeriods = paymentPeriods.map(p => languageFile[`GENERAL.FORMS.${p}`]);

    fields.DelayPaymentPeriod.paymentPeriods = payPeriods;

    if (placeholdersQA.RFQFields) {
        placeholdersQA.RFQFields.values.forEach(fieldItem => {
            const field = fields[fieldItem.field];
            if (field) {
                field.visible = fieldItem.isActive;
                field.label = fieldItem.display;
                field.required = fieldItem.isActive;
            }
        });
    }

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

class RfqRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationType = 'RFQ';
        this.documentType = 'DocumentRFQ';
        this.notifyingParty = props.workflowItem.notifyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<RfqList
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        notificationType={this.notificationType}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <RfqCreate
                                {...this.props}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<RfqDetail
                        {...this.props}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notificationType={this.notificationType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};




export default injectIntl(RfqRouter);